import { DateTime } from 'luxon'

/**
 * Formats a duration in minutes to a string representation.
 * @param minutes - The duration in minutes.
 * @returns A formatted string representing the duration.
 */
export function formatDuration(minutes: number | null): string {
  if (!minutes) return ''
  if (minutes < 60) return `${minutes}m`
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60
  if (remainingMinutes === 0) return `${hours}h`
  return `${hours}h ${remainingMinutes}m`
}

/**
 * Formats a time range given a start time and duration.
 * @param startTime - The start time in 'HH:mm' format.
 * @param durationMinutes - The duration in minutes.
 * @returns A formatted string representing the time range.
 */
export function formatTimeRange(startTime: string, durationMinutes: number): string {
  const start = DateTime.fromFormat(startTime, 'HH:mm')
  if (!durationMinutes) return start.toFormat('h:mm a')

  const end = start.plus({ minutes: durationMinutes })
  return `${start.toFormat('h:mm a')} - ${end.toFormat('h:mm a')}`
}
